import React, { useCallback, useState } from "react";
import { generateQuotePdfDocument } from "../utils/generateQuotePdf";

const QuotePDFButton = ({ quote, items }) => {
  const [busy, setBusy] = useState(false);

  const handleDownload = useCallback(async () => {
    setBusy(true);

    try {
      const doc = await generateQuotePdfDocument({ quote, items });
      doc.save(`${quote.quote_number || "quote"}.pdf`);
    } catch (error) {
      console.error("Failed to generate quote PDF:", error.message);
    } finally {
      setBusy(false);
    }
  }, [quote, items]);

  return (
    <button
      className="crm-secondary-btn"
      onClick={handleDownload}
      disabled={busy}
    >
      {busy ? "Preparing PDF..." : "Download PDF"}
    </button>
  );
};

export default QuotePDFButton;
